import React from 'react';
import PropTypes from 'prop-types';

import { translate } from '../i18n/localize';

function IString(props) {
  const { className, placeholders, stringKey } = props;

  return (
    <span className={className}>{translate(stringKey, placeholders)}</span>
  );
}

IString.propTypes = {
  className: PropTypes.string,
  placeholders: PropTypes.object,
  stringKey: PropTypes.string.isRequired
};

export default IString;
